import { render, staticRenderFns } from "./PCISuccess.vue?vue&type=template&id=3c255a30&scoped=true"
import script from "./PCISuccess.vue?vue&type=script&lang=js"
export * from "./PCISuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c255a30",
  null
  
)

export default component.exports